import * as React from 'react';

import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { User } from '@app/objects/User';
import { Insurance } from '@app/objects/Insurance';
import { InsuranceCards } from '@app/components/Pages/Admin/InsuranceCards/InsuranceCards';

interface Props {
	renderButtons?: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit: (userData?: User) => void;
}

interface InsuranceStepWrapperProps extends Props {
	initialItems?: Array<Insurance>;
}

const InsuranceStep: React.FC<Props> = (props) => {
	const context = useItemsProviderContext<Insurance>();

	if (!context.state) throw 'Need ItemsProvider context!';

	const { state: { items } } = context;

	const [activeKey, setActiveKey] = React.useState('primary');

	React.useEffect(() => {
		if (items && items.length > 0 && items.some((ins) => ins.photoFront || ins.photoBack)) {
			handleSubmit();
		}
	}, []);

	const handleSubmit = () => {
		props.afterSubmit();
	};

	return <>
		<div className="patient-register-page__photo">
			<h4 className="text-center">
				Please take a photo of the patient's
				{' '}
				<b>{activeKey}</b>
				{' '}
				insurance card.
			</h4>
		</div>
		<InsuranceCards
			onTabChange={setActiveKey}
			cardPanelClassName="patient-register-page__wrapper"
		/>
		{props.renderButtons && props.renderButtons(handleSubmit)}
	</>;
};

const InsuranceStepWrapper: React.FC<InsuranceStepWrapperProps> = (props) => {
	return (
		<ItemsProvider<Insurance>
			type="insurance"
			loadRequest="insurancePageViewList"
			items={props.initialItems}
			skipInitLoad={!!props.initialItems}
		>
			<InsuranceStep {...props} />
		</ItemsProvider>
	);
};

export default InsuranceStepWrapper;
